/**
 * Browser origins the Nest API must allow (`CORS_ORIGINS` in root `.env`).
 * Frontend apps do not send CORS headers — copy the matching list to the API env.
 */

/** Local `nx serve` origins (admin 4201, marketing 4300, legacy 4200). */
export const LOCAL_CORS_ORIGINS = [
  'http://localhost:4200',
  'http://localhost:4201',
  'http://localhost:4300',
] as const;

/**
 * Shared development / Cloudflare Pages staging origins.
 * Includes custom dev hosts and default `*.pages.dev` project URLs.
 */
export const DEVELOPMENT_CORS_ORIGINS = [
  'https://dev-booking.clinic.com',
  'https://dev-app.clinic.com',
  'https://mcore.pages.dev',
  'https://mcore-admin.pages.dev',
  ...LOCAL_CORS_ORIGINS,
] as const;

/** Comma-separated value for API `CORS_ORIGINS` (no spaces). */
export function corsOriginsToEnv(origins: readonly string[]): string {
  return origins.join(',');
}
